import { render, staticRenderFns } from "./MyOrganization.vue?vue&type=template&id=8c7091b8&scoped=true&"
import script from "./MyOrganization.vue?vue&type=script&lang=js&"
export * from "./MyOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7091b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c7091b8')) {
      api.createRecord('8c7091b8', component.options)
    } else {
      api.reload('8c7091b8', component.options)
    }
    module.hot.accept("./MyOrganization.vue?vue&type=template&id=8c7091b8&scoped=true&", function () {
      api.rerender('8c7091b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ddv-home/MyOrganization.vue"
export default component.exports